export default __webpack_public_path__ + "static/media/eq-sp.562b2d3a.svg";